module.exports = "<div data-bind=\"css: className\">\n  <!-- ko foreach: { data: items, as: 'content' } -->\n  <!-- ko template: { name: 'se-component-' + content, data: $parent.context } -->\n  <!-- /ko -->\n  <!-- /ko -->\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader?interpolate!./~/val-loader!./src/utils/designer-h-container.html
// module id = 159
// module chunks = 0